/** First-segment URL prefixes for localized pages. English uses `/` (no prefix). */
export const URL_PREFIX_LANGUAGES = ["de", "fr"] as const;

export type UrlPrefixLanguage = (typeof URL_PREFIX_LANGUAGES)[number];

export function isUrlPrefixLanguage(
  segment: string | undefined,
): segment is UrlPrefixLanguage {
  return (
    segment !== undefined &&
    (URL_PREFIX_LANGUAGES as readonly string[]).includes(segment)
  );
}
